import { HttpInterceptor, HttpXsrfTokenExtractor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/do';
import  { UserSessionService } from 'app/services/user-session.service';
import  { UserStorageService } from 'app/services/user-storage.service';
import { Router } from '@angular/router';
 
@Injectable()
export class HttpXsrfInterceptor implements HttpInterceptor {

  constructor(private tokenExtractor: HttpXsrfTokenExtractor, private userSession: UserSessionService, private userStorage: UserStorageService, private router: Router) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    let tokenLaravel = this.userSession.get();
    if (tokenLaravel != null){
      req = req.clone({ headers: req.headers.set('Authorization', 'Bearer '+ tokenLaravel) });
    }
    return next.handle(req)
          .do((evento: HttpEvent<any>) => {
            if (evento instanceof HttpResponse) {
              let body = evento.body as string;
              if(evento.status == 200 && evento.body.token){
                let token = evento.body.token;
                this.userSession.set(token);
              }
              
              if(evento.body.status == "Token is Expired"){
                this.userSession.deleteToken();
                this.router.navigate(['/lockscreen']);
              }
            }
          }).catch(resposta => {
            if (resposta instanceof HttpErrorResponse) {
              
            }
    
            return Observable.throw(resposta);
          });
    
  }
}



// WEBPACK FOOTER //
// ./src/app/interceptors/HttpXsrfInterceptor.ts